import React, { FC } from 'react';
import styled from 'styled-components';
import { StatusFieldOption } from 'api/tasks';
import { BaseCell } from 'components/organisms/timesheets/common/timesheet-table';
import { renderStatusField } from 'utils/render-status-field';

const Cell = styled(BaseCell)`
  .ant-col {
    display: flex;
    height: 18px;
  }
  svg {
    width: 18px;
    height: 18px;
  }
`;

export const StatusCell: FC<{ status: StatusFieldOption }> = ({ status }) => (
  <Cell>{renderStatusField(status?.value, status)}</Cell>
);
